var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:rgb(17,24,39);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.171875,11.8452148h-1c-0.0005035,1.6310921-0.6582479,3.0985098-1.7265778,4.1684418 c-1.069932,1.068327-2.5373468,1.7260742-4.1684418,1.7265778c-1.631094-0.0005035-3.0985122-0.6582489-4.1684427-1.7265778 c-1.0683317-1.069932-1.7260771-2.5373468-1.7265773-4.1684418c0.0005012-1.631094,0.658246-3.0985126,1.7265773-4.1684427 c1.069932-1.0683317,2.537343-1.7260771,4.1684427-1.7265773c1.6310921,0.0005012,3.0985098,0.658246,4.1684418,1.7265773 c1.068327,1.069931,1.7260742,2.537343,1.7265778,4.1684427H17.171875h0.9999981 c-0.0006332-4.3607554-3.5342627-7.8943892-7.8950176-7.8950195C5.9161,3.9508266,2.3824663,7.4844565,2.3818359,11.8452148 c0.0006318,4.360754,3.5342612,7.8943825,7.8950195,7.8950176c4.360754-0.0006332,7.8943825-3.5342636,7.8950176-7.8950176 H17.171875z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3317366,16.4545269l5.0722647,3.5693359c0.451664,0.3178349,1.0754642,0.209343,1.3932991-0.2423191 c0.3178349-0.451664,0.209343-1.0754642-0.2423191-1.3932991l-5.0722656-3.569335 c-0.451664-0.3178349-1.0754642-0.2093439-1.3932981,0.2423191C14.7715826,15.5128927,14.8800735,16.136692,15.3317366,16.4545269"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5f605273a597eea60fbbb983ffb04fef.svg";
export { ForwardRef as ReactComponent };